import { useCallback } from "react";
import { useVisible } from "../../../../../../utils/hooks/useVisible";
import { useUpdateTimeSheet } from "../../../../api/useUpdateTimeSheet";
import useApi from "../../../../../../utils/api";
import { formatTimeSheetParams } from "../../../../api/helpers";
import { useDateFilters } from "../../../DateAndPayGroupFilters/useDateFilters";
import { useActionWithAccess } from "../../../../../../utils/hooks/access";

export const useEdit = ({ refetch, filters, isMyTimesheet = false }) => {
	const { visible, open, close, selected } = useVisible();
	const { authGet } = useApi();
	const { from, to } = useDateFilters();
	const { submit, loading, error } = useUpdateTimeSheet({ isMyTimesheet });

	const submitEdit = useActionWithAccess(
		useCallback(
			async (id, data) => {
				submit(id, { note: data?.note }, async ({ user: { id } }) => {
					return await authGet("/time-sheet/manager-view/", {
						params: {
							userId: id,
							...formatTimeSheetParams({
								from,
								to,
								filters
							}),
						},
					}).then((response) => {
						close();
						refetch(response);
					})
				});
			},
			[submit, refetch, authGet, close, from, to, filters],
		),
		"timeSheet.canEdit",
	);

	return {
		visible,
		open,
		close,
		selected,
		loading,
		error,
		submit: submitEdit,
	};
};
